import React from "react";
import PropTypes from "prop-types";
import { ProgressContainer, ProgressBar } from "./styles"; // adjust path
import { capitalizeFirstLetter, commaSeperator } from "../../utils/methods";

const MonthlyGoalProgress = ({ item }) => {
  const totalSteps =
    item?.challenge_participants?.challenge_level?.total_activity || 0;

  const monthlyTarget =
    item?.challenge_participants?.challenge_level?.monthly_target_steps || 0;

  const activityType =
    item?.challenge_participants?.challenge_level?.activity_type || "steps";

  // If data is missing, render nothing
  if (!monthlyTarget) return null;

  const progressPercentage = Math.min(
    Math.round(( totalSteps/ monthlyTarget) * 100),
    100
  );

  return (
    <>
      <ProgressContainer isFontSize="16px">
        <div className="progressText">
          Progress - <span className="value">&nbsp;{commaSeperator(totalSteps)}  {capitalizeFirstLetter(activityType)}</span>
        </div>

        <div className="progressText">
          Goal -  <span className="value">&nbsp;{commaSeperator(monthlyTarget)}  {capitalizeFirstLetter(activityType)}</span>
        </div>
      </ProgressContainer>

      <ProgressBar progress={`${progressPercentage}%`} isColor={activityType == "steps" ? "#DA6C74" : activityType == "miles" ? "#DA9B6C" : "#75B084" }>
        <div
          className="barWidth"
          style={{ width: `${progressPercentage}%` }}
        />
      </ProgressBar>
    </>
  );
};

MonthlyGoalProgress.propTypes = {
  item: PropTypes.object.isRequired,
};

export default MonthlyGoalProgress;
